function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var main = createCommonjsModule(function (module, exports) {
  !function (e, i) {
    for (var t in i) {
      e[t] = i[t];
    }
  }(exports, function (e) {
    var i = {};

    function t(a) {
      if (i[a]) return i[a].exports;
      var r = i[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    return t.m = e, t.c = i, t.d = function (e, i, a) {
      t.o(e, i) || Object.defineProperty(e, i, {
        enumerable: !0,
        get: a
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, i) {
      if (1 & i && (e = t(e)), 8 & i) return e;
      if (4 & i && "object" == typeof e && e && e.__esModule) return e;
      var a = Object.create(null);
      if (t.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: e
      }), 2 & i && "string" != typeof e) for (var r in e) {
        t.d(a, r, function (i) {
          return e[i];
        }.bind(null, r));
      }
      return a;
    }, t.n = function (e) {
      var i = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(i, "a", i), i;
    }, t.o = function (e, i) {
      return Object.prototype.hasOwnProperty.call(e, i);
    }, t.p = "", t(t.s = 0);
  }([function (e, i, t) {
    var a = i.contexts = new Map(),
        r = i.constants = t(1);
    a.set(r.SECURITY_CONTEXT_V1_URL, t(2)), a.set(r.SECURITY_CONTEXT_V2_URL, t(3));
  }, function (e, i, t) {
    i.SECURITY_CONTEXT_V1_URL = "https://w3id.org/security/v1", i.SECURITY_CONTEXT_V2_URL = "https://w3id.org/security/v2";
  }, function (e, i) {
    e.exports = {
      "@context": {
        id: "@id",
        type: "@type",
        dc: "http://purl.org/dc/terms/",
        sec: "https://w3id.org/security#",
        xsd: "http://www.w3.org/2001/XMLSchema#",
        EcdsaKoblitzSignature2016: "sec:EcdsaKoblitzSignature2016",
        Ed25519Signature2018: "sec:Ed25519Signature2018",
        EncryptedMessage: "sec:EncryptedMessage",
        GraphSignature2012: "sec:GraphSignature2012",
        LinkedDataSignature2015: "sec:LinkedDataSignature2015",
        LinkedDataSignature2016: "sec:LinkedDataSignature2016",
        CryptographicKey: "sec:Key",
        authenticationTag: "sec:authenticationTag",
        canonicalizationAlgorithm: "sec:canonicalizationAlgorithm",
        cipherAlgorithm: "sec:cipherAlgorithm",
        cipherData: "sec:cipherData",
        cipherKey: "sec:cipherKey",
        created: {
          "@id": "dc:created",
          "@type": "xsd:dateTime"
        },
        creator: {
          "@id": "dc:creator",
          "@type": "@id"
        },
        digestAlgorithm: "sec:digestAlgorithm",
        digestValue: "sec:digestValue",
        domain: "sec:domain",
        encryptionKey: "sec:encryptionKey",
        expiration: {
          "@id": "sec:expiration",
          "@type": "xsd:dateTime"
        },
        expires: {
          "@id": "sec:expiration",
          "@type": "xsd:dateTime"
        },
        initializationVector: "sec:initializationVector",
        iterationCount: "sec:iterationCount",
        nonce: "sec:nonce",
        normalizationAlgorithm: "sec:normalizationAlgorithm",
        owner: {
          "@id": "sec:owner",
          "@type": "@id"
        },
        password: "sec:password",
        privateKey: {
          "@id": "sec:privateKey",
          "@type": "@id"
        },
        privateKeyPem: "sec:privateKeyPem",
        publicKey: {
          "@id": "sec:publicKey",
          "@type": "@id"
        },
        publicKeyBase58: "sec:publicKeyBase58",
        publicKeyPem: "sec:publicKeyPem",
        publicKeyWif: "sec:publicKeyWif",
        publicKeyService: {
          "@id": "sec:publicKeyService",
          "@type": "@id"
        },
        revoked: {
          "@id": "sec:revoked",
          "@type": "xsd:dateTime"
        },
        salt: "sec:salt",
        signature: "sec:signature",
        signatureAlgorithm: "sec:signingAlgorithm",
        signatureValue: "sec:signatureValue"
      }
    };
  }, function (e, i) {
    e.exports = {
      "@context": [{
        "@version": 1.1
      }, "https://w3id.org/security/v1", {
        AesKeyWrappingKey2019: "sec:AesKeyWrappingKey2019",
        DeleteKeyOperation: "sec:DeleteKeyOperation",
        DeriveSecretOperation: "sec:DeriveSecretOperation",
        EcdsaSecp256k1Signature2019: "sec:EcdsaSecp256k1Signature2019",
        EcdsaSecp256r1Signature2019: "sec:EcdsaSecp256r1Signature2019",
        EcdsaSecp256k1VerificationKey2019: "sec:EcdsaSecp256k1VerificationKey2019",
        EcdsaSecp256r1VerificationKey2019: "sec:EcdsaSecp256r1VerificationKey2019",
        Ed25519Signature2018: "sec:Ed25519Signature2018",
        Ed25519VerificationKey2018: "sec:Ed25519VerificationKey2018",
        EquihashProof2018: "sec:EquihashProof2018",
        ExportKeyOperation: "sec:ExportKeyOperation",
        GenerateKeyOperation: "sec:GenerateKeyOperation",
        KmsOperation: "sec:KmsOperation",
        RevokeKeyOperation: "sec:RevokeKeyOperation",
        RsaSignature2018: "sec:RsaSignature2018",
        RsaVerificationKey2018: "sec:RsaVerificationKey2018",
        Sha256HmacKey2019: "sec:Sha256HmacKey2019",
        SignOperation: "sec:SignOperation",
        UnwrapKeyOperation: "sec:UnwrapKeyOperation",
        VerifyOperation: "sec:VerifyOperation",
        WrapKeyOperation: "sec:WrapKeyOperation",
        X25519KeyAgreementKey2019: "sec:X25519KeyAgreementKey2019",
        allowedAction: "sec:allowedAction",
        assertionMethod: {
          "@id": "sec:assertionMethod",
          "@type": "@id",
          "@container": "@set"
        },
        authentication: {
          "@id": "sec:authenticationMethod",
          "@type": "@id",
          "@container": "@set"
        },
        capability: {
          "@id": "sec:capability",
          "@type": "@id"
        },
        capabilityAction: "sec:capabilityAction",
        capabilityChain: {
          "@id": "sec:capabilityChain",
          "@type": "@id",
          "@container": "@list"
        },
        capabilityDelegation: {
          "@id": "sec:capabilityDelegationMethod",
          "@type": "@id",
          "@container": "@set"
        },
        capabilityInvocation: {
          "@id": "sec:capabilityInvocationMethod",
          "@type": "@id",
          "@container": "@set"
        },
        caveat: {
          "@id": "sec:caveat",
          "@type": "@id",
          "@container": "@set"
        },
        challenge: "sec:challenge",
        ciphertext: "sec:ciphertext",
        controller: {
          "@id": "sec:controller",
          "@type": "@id"
        },
        delegator: {
          "@id": "sec:delegator",
          "@type": "@id"
        },
        equihashParameterK: {
          "@id": "sec:equihashParameterK",
          "@type": "xsd:integer"
        },
        equihashParameterN: {
          "@id": "sec:equihashParameterN",
          "@type": "xsd:integer"
        },
        invocationTarget: {
          "@id": "sec:invocationTarget",
          "@type": "@id"
        },
        invoker: {
          "@id": "sec:invoker",
          "@type": "@id"
        },
        jws: "sec:jws",
        keyAgreement: {
          "@id": "sec:keyAgreementMethod",
          "@type": "@id",
          "@container": "@set"
        },
        kmsModule: {
          "@id": "sec:kmsModule"
        },
        parentCapability: {
          "@id": "sec:parentCapability",
          "@type": "@id"
        },
        plaintext: "sec:plaintext",
        proof: {
          "@id": "sec:proof",
          "@type": "@id",
          "@container": "@graph"
        },
        proofPurpose: {
          "@id": "sec:proofPurpose",
          "@type": "@vocab"
        },
        proofValue: "sec:proofValue",
        referenceId: "sec:referenceId",
        unwrappedKey: "sec:unwrappedKey",
        verificationMethod: {
          "@id": "sec:verificationMethod",
          "@type": "@id"
        },
        verifyData: "sec:verifyData",
        wrappedKey: "sec:wrappedKey"
      }]
    };
  }]));
});
var main$1 = unwrapExports(main);
var main_1 = main.contexts;
var main_2 = main.constants;
export default main$1;
export { main_2 as constants, main_1 as contexts };